import React from 'react';

import Button from '@mui/material/Button';
import {
  alpha,
  useTheme,
  type SxProps,
  type Theme,
} from '@mui/material/styles';
import PlayArrow from '@mui/icons-material/PlayArrow';

interface RunBulkOpButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export default function RunBulkOpButton({
  onClick,
  disabled = false,
}: Readonly<RunBulkOpButtonProps>) {
  const theme = useTheme();

  const sx: SxProps<Theme> = {
    height: 28,
    width: 115,
    minWidth: 115,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.semantic.button.secondary.border}`,
    color: theme.palette.semantic.button.secondary.border,
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'none',
    paddingX: 1,
    ':hover': {
      borderColor: theme.palette.semantic.hyperlink.active,
      color: theme.palette.semantic.hyperlink.active,
    },
    '&.Mui-disabled': {
      border: `1px solid ${alpha(theme.palette.action.disabled, 0.3)}`,
      color: theme.palette.action.disabled,
    },
  };

  return (
    <Button
      variant="outlined"
      size="small"
      color="primary"
      disabled={disabled}
      startIcon={<PlayArrow fontSize="small" />}
      onClick={onClick}
      sx={sx}
    >
      Run Bulk Op
    </Button>
  );
}
